import React__default from 'react';
import { EditUserProfileProvider } from './EditUserProfile/context.js';
import { EditUserProfileUI } from './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-Ca6003_X.js';
import './chunks/bundle-s19NuPaM.js';
import './chunks/bundle-DLMIiDGU.js';
import './chunks/bundle-DGylLBIn.js';
import './chunks/bundle-CCo7ZdMR.js';
import 'react-dom';
import './chunks/bundle-91Yg-xh6.js';
import './chunks/bundle-CPSJLEbT.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DDzCV2KR.js';
import './ui/Icon.js';
import './chunks/bundle-C6Xiexo0.js';
import './chunks/bundle-ByN2OJfK.js';
import './chunks/bundle-Dcb1dUnS.js';
import './chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import './ui/Input.js';
import './chunks/bundle-zHBlW_wn.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_bjYbrN.js';
import './ui/TextButton.js';
import './chunks/bundle-DMyARZj7.js';

var EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};

export { EditUserProfile as default };
//# sourceMappingURL=EditUserProfile.js.map
